import { ManualAnalysisPanelState } from "@/@types/vuex";
import { MutationTree } from "vuex";

export enum ManualAnalysisPanelMutation {}

const mutations: MutationTree<ManualAnalysisPanelState> = {};

export default mutations;
